import { html } from 'fxjs/es';

export const labsLoaderTmpl = () => {
  return html`
    <div class="ness-labs-loader">
      <div class="ness-labs-loader__logo"></div>
      <p class="ness-labs-loader__message">
        선택하신 캐릭터 정보를 상품에 반영하고 있어요.<br />조금만 기다려 주세요!
      </p>
    </div>
  `;
};
